import React from 'react';

const CodPrice = (props) => {

    return (
        <React.Fragment>
            {
                props.data.package.cod_price &&
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ paddingLeft: '4px', whiteSpace: 'nowrap' }}>
                        {props.data.package.cod_price ? parseFloat(props.data.package.cod_price).toFixed(2) + ' ' + props.data.package.cod_currency_code.toUpperCase() : null}
                    </div>
                </div>
            }
        </React.Fragment>
    );
};

export default CodPrice;
